import { useParams } from 'react-router-dom';
import { useQuery } from 'urql';
import { DeploymentForm } from '~/components/assets/DeploymentForm';
import { AssetDocument } from '~/generated/graphql';

export default function SiteAssetDeploy() {
  const { siteId, assetId } = useParams();

  // Load asset data to pass to DeploymentForm
  const [{ data: assetData, fetching }] = useQuery({
    query: AssetDocument,
    variables: { id: assetId || '' },
    pause: !assetId,
  });

  const asset = assetData?.asset;

  if (fetching) {
    return (
      <div className='flex h-full items-center justify-center overflow-hidden'>
        <div>Loading...</div>
      </div>
    );
  }

  return (
    <div className='h-full overflow-hidden'>
      <DeploymentForm
        asset={asset ? { id: asset.id, name: asset.name } : undefined}
        onClose={() => {
          // Navigate back to site asset view instead of main assets
          window.history.back();
        }}
      />
    </div>
  );
}
